// extracted by mini-css-extract-plugin
export var completionBody = "_jb-2";
export var completionCard = "_jb-0";
export var completionFooter = "_jb-3";
export var completionTitle = "_jb-1";